module.exports = __webpack_public_path__ + "static/img/sd.f41f38c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/sd.png
// module id = /j5F
// module chunks = 0